import React, { useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCenterDetails, clearError, clearLocationDetails } from '../../../redux/Slices/LocationsSlice';
import { showErrorToast } from '../../../shared/utils/toastHelper';

const CenterDetails = () => {
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    
    const { centerDetails, loading, error } = useSelector((state) => state.locations);

    useEffect(() => {
        setTitle('تفاصيل المركز');
        dispatch(fetchCenterDetails(id));
        
        return () => {
            dispatch(clearLocationDetails());
        };
    }, [setTitle, dispatch, id]);

    useEffect(() => {
        if (error) {
            showErrorToast(error);
            dispatch(clearError());
        }
    }, [error, dispatch]);

    if (loading || !centerDetails) {
        return (
            <div className="main_content text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-muted">جاري تحميل بيانات المركز...</p>
            </div>
        );
    }

    return (
        <div className="main_content">
            <div className="dashboard-container">
                <div className="card shadow-lg border-0">
                    <div className="card-header bg-white pb-0 border-0 d-flex justify-content-between align-items-center">
                        <h4 className="mb-0">تفاصيل المركز #{id}</h4>
                        <div>
                            <button className="btn btn-warning mx-2 text-white" onClick={() => navigate(`/admin-locations/centers/${id}/edit`)}>
                                تعديل
                            </button>
                            <button className="btn btn-secondary" onClick={() => navigate('/admin-locations/centers')}>
                                عودة للقائمة
                            </button>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row g-4 mt-2">
                            <div className="col-md-6 border-bottom pb-3">
                                <h6>اسم المركز (بالعربية)</h6>
                                <p className="text-muted fw-bold mb-0">{centerDetails.name_ar || centerDetails.name || '-'}</p>
                            </div>
                            <div className="col-md-6 border-bottom pb-3">
                                <h6>اسم المركز (بالإنجليزية)</h6>
                                <p className="text-muted fw-bold mb-0">{centerDetails.name_en || '-'}</p>
                            </div>
                            {/* <div className="col-md-6 border-bottom pb-3">
                                <h6>رقم المحافظة التابع لها</h6>
                                <p className="text-muted fw-bold mb-0">{centerDetails.government_id || '-'}</p>
                            </div> */}
                            <div className="col-md-6 border-bottom pb-3">
                                <h6>الكود</h6>
                                <p className="text-muted mb-0">{centerDetails.code || '-'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CenterDetails;
